import React, {} from 'react'
import {Redirect} from 'react-router-dom'

const Assignee = () => <Redirect to={'/assignee/home'}/>;

export default Assignee;
